"use client";

import { type Brand } from "@/types/general";

export const getBrandClient = (): Brand => {
  const host = global.window?.location.host;

  return host?.includes("stone.com.br") ? "stone" : "ton";
};
